import React from "react";

const ConditionTabContent = () => {
  return (
    <div className="text-sm text-gray-300 ml-3 mt-2">
      🧠 Condition tab content coming soon...
    </div>
  );
};

export default ConditionTabContent;
